// extracted by mini-css-extract-plugin
module.exports = {"universeAddBtn":"styles__universeAddBtn--3pLT6","deleteBtn":"styles__deleteBtn--3CydE"};